import { useTheme } from '@emotion/react';
import { useSetAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import React, { useCallback } from 'react';

import { Button, Icon } from '~/components/blocks';
import {
  newPatientDrawerState,
  newPatientFromCheckinEntryDrawerState,
} from '~/state/patient/atoms';

export const NewPatientButton = () => {
  const theme = useTheme();
  const setNewPatientDrawerState = useSetAtom(newPatientDrawerState);
  const resetNewPatientFromCheckinEntryDrawerState = useResetAtom(
    newPatientFromCheckinEntryDrawerState,
  );
  const handleClick = useCallback(() => {
    setNewPatientDrawerState((_state) => ({ ..._state, isOpen: true }));
    resetNewPatientFromCheckinEntryDrawerState();
  }, [setNewPatientDrawerState, resetNewPatientFromCheckinEntryDrawerState]);

  return (
    <Button size="s" paddingX={theme.space.m} onClick={handleClick}>
      <Icon icon="plus" color="green" size="xl" />
      患者登録
    </Button>
  );
};
